import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "@/modules/auth";

// Bootstrap styles must be imported before our custom styles so that we can override them
import "bootstrap/dist/css/bootstrap.min.css";

// Antd styles imported on top so it does not effect bootstrap and custom styles
import "~/custom-antd.less";
import "~/index.css";

import "~/config/setupMoment";
import "~/i18n";
import "~/sentry";

import App from "./App";

async function enableMocking() {
  if (import.meta.env.ENABLE_MOCKING !== "true") {
    return;
  }
  const { worker } = await import("../modules/integrations/banking/mocks");
  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

enableMocking().then(() => {
  ReactDOM.render(
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>,
    document.getElementById("root")
  );
});
